import { uiSize } from '@utils'

interface Props {
  color?: string
  stroke?: string
}

function AddIcon({ color = 'var(--icon-add-bg)', stroke = 'var(--banky-white)' }: Props) {
  return (
    <svg width={uiSize(26)} height={uiSize(26)} viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='26' height='26' rx='8' fill={color} />
      <path d='M13 8.125V17.875' stroke={stroke} strokeWidth='1.6' strokeLinejoin='round' />
      <path d='M17.875 13L8.125 13' stroke={stroke} strokeWidth='1.6' strokeLinejoin='round' />
    </svg>
  )
}

export default AddIcon
